<template>
  <div>
    <div class="floating-btn-back d-flex align-items-center p-2">
      <svg @click="back" xmlns="http://www.w3.org/2000/svg" width="38" height="38" fill="#fff"
        class="bi bi-arrow-left-circle-fill mx-2" viewBox="0 0 16 16">
        <path
          d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z" />
      </svg>
    </div>
    <div class="d-flex justify-content-center align-items-center">
      <mastering-component :categ="catg" />
    </div>
  </div>
</template>

<script>
import MasteringComponent from "../components/MasteringComponent.vue";

import { mapState } from "vuex";
export default {
  components: {
    MasteringComponent,
  },
  mounted() {
    this.$route.params.cat ? (localStorage.cat = this.$route.params.cat) : "";
    this.$store.dispatch("apiEvents/fetchActiveGroups", {
      isSimple: this.isSimple,
      trackCategory: localStorage.cat,
    });
  },
  data() {
    return {
      catg: this.$route.params.cat ? this.$route.params.cat : localStorage.cat,
    };
  },

  computed: {
    ...mapState(["apiEvents"], ["trackData"]),
    isSimple() {
      // return this.$store.state.trackData.trackStyle == "Simple" ? true : false;
      return false;
    },
  },
  methods: {
    back() {
      this.$router.push("../dashboard");
    },
  },
};
</script>
<style scoped></style>
